module.exports = __webpack_public_path__ + "img/ICFA-logo.6e61141.png";